// FavoriteButton — reusable heart toggle that calls TripContext.
import { Heart } from "lucide-react";
import { useTrip } from "../auth/TripContext";

export default function FavoriteButton({ kind, ref: refId, size = 16, className = "" }) {
  const { isFavorite, toggleFavorite, tripId } = useTrip();
  if (!tripId) return null; // not in a trip context
  const active = isFavorite(kind, refId);
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        toggleFavorite(kind, refId);
      }}
      className={`w-8 h-8 rounded-full flex items-center justify-center transition-all active:scale-90 ${
        active
          ? "bg-[hsl(var(--accent))]/15 text-[hsl(var(--accent))]"
          : "text-[hsl(var(--muted))] hover:text-[hsl(var(--ink))]"
      } ${className}`}
      aria-label={active ? "Quitar de favoritos" : "Añadir a favoritos"}
      data-testid={`fav-toggle-${kind}-${refId}`}
    >
      <Heart size={size} fill={active ? "currentColor" : "none"} strokeWidth={active ? 0 : 2} />
    </button>
  );
}
